import { CurrentGameResponseData } from "@lib/titan2-slingo/dist/api/data/CurrentGameResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ExtendedConfigData } from "../../data/ExtendedConfigData";
/**
 * ExtendedCurrentGameResponseData.ts
 */
export class ExtendedCurrentGameResponseData extends CurrentGameResponseData {
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
            if (this.gameUpdate.hasFreeGame()) {
                this.updateStake(this.gameUpdate.getFreeGameStake());
            }
            else if (this.gameUpdate.hasLastStake()) {
                this.updateStake(this.gameUpdate.getLastStake());
            }
        }
    }
    solidifyConfig() {
        let config = this.data.getDataObject(SlingoConstants.PROPERTY_CONFIG);
        if (this.dataExists(config)) {
            this.config = new ExtendedConfigData(config);
        }
    }
}
//# sourceMappingURL=ExtendedCurrentGameResponseData.js.map